/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import TagConstants from 'constants/TagConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'

const TagQueries = Marty.createQueries({
  id: 'TagQueries',

  fetchTagsForOrgId(orgId) {
    const promise = this.app.sources.TagAPI.fetchTagsForOrgId(orgId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(TagConstants.TAG_LIST_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_LIST_FETCH_FAILED, res, orgId)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_LIST_FETCH_FAILED, error, orgId)
    })
  },

  createTagForOrgId(orgId, tagParams) {
    const promise = this.app.sources.TagAPI.createTagForOrgId(orgId, tagParams)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(TagConstants.TAG_CREATE_DONE, res.body)
        return this.app.actions.NotificationActions.pushNotification({
          content: `'${ res.body.name }' tag has been saved!`
        })
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_CREATE_FAILED, res, orgId, tagParams)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_CREATE_FAILED, error, orgId, tagParams)
    })
  },

  updateTagForOrgId(orgId, tagId, tagParams) {
    const promise = this.app.sources.TagAPI.updateTagForOrgId(orgId, tagId, tagParams)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(TagConstants.TAG_UPDATE_DONE, res.body)
        return this.app.actions.NotificationActions.pushNotification({
          content: `'${ res.body.name }' tag has been updated!`
        })
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_UPDATE_FAILED, res, orgId, tagId, tagParams)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_UPDATE_FAILED, error, orgId, tagId, tagParams)
    })
  },

  deleteTagForOrgId(orgId, tagId) {
    const promise = this.app.sources.TagAPI.deleteTagForOrgId(orgId, tagId)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(TagConstants.TAG_DELETE_DONE, tagId)
        return this.app.actions.NotificationActions.pushNotification({
          content: 'Tag has been deleted!',
          variant: 'red'
        })
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_DELETE_FAILED, res, orgId, tagId)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_DELETE_FAILED, error, orgId, tagId)
    })
  },

  addTagsToConversationId(conversationId, tagIds) {
    const promise = this.app.sources.TagAPI.addTagsToConversationId(conversationId, tagIds)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(TagConstants.TAG_ADD_TO_CONVERSATION_ID_DONE, conversationId, tagIds)
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_ADD_TO_CONVERSATION_ID_FAILED, res, conversationId, tagIds)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_ADD_TO_CONVERSATION_ID_FAILED, error, conversationId, tagIds)
    })
  },

  removeTagsFromConversationId(conversationId, tagIds) {
    const promise = this.app.sources.TagAPI.removeTagsFromConversationId(conversationId, tagIds)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(TagConstants.TAG_REMOVE_FROM_CONVERSATION_ID_DONE, conversationId, tagIds)
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_REMOVE_FROM_CONVERSATION_ID_FAILED, res, conversationId, tagIds)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_REMOVE_FROM_CONVERSATION_ID_FAILED, error, conversationId, tagIds)
    })
  },

  addTagsToCompanyId(companyId, tagIds) {
    const promise = this.app.sources.TagAPI.addTagsToCompanyId(companyId, tagIds)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(TagConstants.TAG_ADD_TO_COMPANY_ID_DONE, companyId, tagIds)
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_ADD_TO_COMPANY_ID_FAILED, res, companyId, tagIds)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_ADD_TO_COMPANY_ID_FAILED, error, companyId, tagIds)
    })
  },

  removeTagsFromCompanyId(companyId, tagIds) {
    const promise = this.app.sources.TagAPI.removeTagsFromCompanyId(companyId, tagIds)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(TagConstants.TAG_REMOVE_FROM_COMPANY_ID_DONE, companyId, tagIds)
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_REMOVE_FROM_COMPANY_ID_FAILED, res, companyId, tagIds)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_REMOVE_FROM_COMPANY_ID_FAILED, error, companyId, tagIds)
    })
  },

  addTagsToEndUserId(endUserId, tagIds) {
    const promise = this.app.sources.TagAPI.addTagsToEndUserId(endUserId, tagIds)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(TagConstants.TAG_ADD_TO_END_USER_ID_DONE, endUserId, tagIds)
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_ADD_TO_END_USER_ID_FAILED, res, endUserId, tagIds)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_ADD_TO_END_USER_ID_FAILED, error, endUserId, tagIds)
    })
  },

  removeTagsFromEndUserId(endUserId, tagIds) {
    const promise = this.app.sources.TagAPI.removeTagsFromEndUserId(endUserId, tagIds)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(TagConstants.TAG_REMOVE_FROM_END_USER_ID_DONE, endUserId, tagIds)
      } else {
        captureResponseException(res)
        return this.dispatch(TagConstants.TAG_REMOVE_FROM_END_USER_ID_FAILED, res, endUserId, tagIds)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(TagConstants.TAG_REMOVE_FROM_END_USER_ID_FAILED, error, endUserId, tagIds)
    })
  },

  setResponseTags(campaignId, conversationId, questionId, tagIds) {
    return this.app.sources.TagAPI.setResponseTags(campaignId, conversationId, questionId, tagIds)
      .then(data => {
        return this.dispatch(TagConstants.TAG_RESPONSE_DONE, campaignId, conversationId, questionId, data.tags)
      }).catch(error => {
        captureException(error)
        return this.dispatch(TagConstants.TAG_RESPONSE_FAILED, error)
      })
  }
})

export default TagQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/TagQueries.js